var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLnkIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-ce1b873e-45af-4bf0-b062-42f25e16c17b",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5.625,
    y: 12.533,
    width: 4.5,
    height: 13.858,
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.875,5.609c-1.451,0-2.398,1.039-2.368,2.425-.03,1.324.918,2.394,2.339,2.394,1.48,0,2.428-1.071,2.428-2.394-.03-1.386-.947-2.425-2.398-2.425Z",
    style: {
      fill: "#d8d8d8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m21.314,12.208c-1.96,0-3.306.93-4.056,1.77v-1.445h-4.5v13.858h4.5v-7.73c0-.415.059-.859.178-1.125.296-.829,1.036-1.687,2.28-1.687,1.628,0,2.279,1.273,2.279,3.138v7.404h4.5v-7.967c0-4.263-2.22-6.217-5.18-6.217Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLnkIn);
export default __webpack_public_path__ + "static/media/LnkIn.5d6a9eafc3adcae5ef1b5db78aaa9616.svg";
export { ForwardRef as ReactComponent };